export default __webpack_public_path__ + "static/media/video.463bd972.png";